<template>
    <div class="login">
        <div class="login-container">
            <p class="title">南外人考试系统</p>
            <input type="text" placeholder="请输入您的账号" v-model="name" />
            <input type="password" placeholder="请输入您的密码" v-model="password" />
            <a @click="login()">登录</a>
        </div>
    </div>
</template>

<script>
// 引入mixins
import mixins_config from "@/mixins/config.js";

// 引入接口
import { LOGIN } from "../utils/dataProvider.js";
import {setLocalStorage, setStorage} from "../utils/cookie";

export default {
    name: "PermanentLogin",
    mixins: [mixins_config],
    components: {},
    data() {
        return {
            name: "",
            password: ""
        };
    },
    mounted() {},
    methods: {
        login() {
            let that = this;
            if (!that.name || !that.password) {
                that.$message.error("请输入您的用户名或密码！");
            } else {
                LOGIN(that.name, that.password, true, function(res) {
                    if (!res) {
                        that.$message.error("请输入正确的用户名或密码！");
                    } else {
                        if (res.status === 200) {
                            console.log('admin登陆');
                            setStorage("token", res.data.token);
                            that.$message.success("登录成功", 3, function() {
                                that.$router.push({
                                    path: that.$route.query.from
                                });
                                setTimeout(() => {
                                    location.reload();
                                }, 10);
                            });
                        }
                    }
                }).catch(err => {
                    console.log(err);
                    that.$message.error(err.response.data);
                });
            }
        }
    }
};
</script>